const getNumberValue = (value: number | string | null | undefined): number => {
  const number = Number(value ?? 0);

  return Number.isNaN(number) ? 0 : number;
};

export default getNumberValue;
